import Theme from './index.vue';

export default Theme;
